/**
 * One glyph and one ordering for the nine roles.
 *
 * These two maps used to be copy-pasted into RoleSelectionSheet,
 * HowReDIWorksSheet and the sign-up form, which meant a new role had to be
 * added in three places and a changed glyph in three more. The audience
 * intro pages (src/constants/audiences.ts) would have made it four, so they
 * moved here instead.
 *
 * Labels and blurbs are NOT here. USER_ROLE_META in src/types/index.ts is
 * the source of truth for those, and stays the place the client's wording
 * gets edited.
 */
import {
  Eye,
  Home,
  Shield,
  Building2,
  HardHat,
  ClipboardCheck,
  Flame,
  Users,
  GraduationCap,
  type LucideIcon,
} from 'lucide-react-native';
import type { UserRole } from '../types';

export const ROLE_ICONS: Record<UserRole, LucideIcon> = {
  'fire-scout': Eye,
  'property-owner': Home,
  'insurance-agent': Shield,
  'insurance-company': Building2,
  contractor: HardHat,
  evaluator: ClipboardCheck,
  'fire-official': Flame,
  'community-leader': Users,
  educator: GraduationCap,
};

/** Fire Scout first and locked on everywhere it is rendered. */
export const ROLE_ORDER: UserRole[] = [
  'fire-scout',
  'property-owner',
  'insurance-agent',
  'insurance-company',
  'contractor',
  'evaluator',
  'fire-official',
  'community-leader',
  'educator',
];
